import { render, staticRenderFns } from "./AppProgramaDia.vue?vue&type=template&id=47162ece&"
import script from "./AppProgramaDia.vue?vue&type=script&lang=ts&"
export * from "./AppProgramaDia.vue?vue&type=script&lang=ts&"
import style0 from "./AppProgramaDia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports